
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  inject: [`team`],
  data () {
    return {
      playerStats: null,
    };
  },
  computed: {
    name () {
      return this.getKnownAs(this.player.player);
    },
    position () {
      return this.player.position !== `Unknown` ? this.player.position : null;
    },
    number () {
      return this.player.squadNumber;
    },
    appearances () {
      return this.playerStats?.appearances;
    },
    positionStat () {
      if (this.playerStats && this.player.position) {
        const stat = this.player.position.includes(`Goalkeeper`) ? `clean_sheet` : `goals`;
        return this.playerStats[stat];
      }
      return null;
    },
    age () {
      if (this.player.player.dateOfBirth) {
        const dob = this.$dayjs(this.player.player.dateOfBirth);
        const now = this.$dayjs();
        return now.diff(dob, `years`);
      }
      return null;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPlayerStats();
    });
  },
  methods: {
    async getPlayerStats () {
      const path = `player/${this.player.player.id}/team/${this.team.id}`;
      const statTypes = [`appearances`, `clean_sheet`, `goals`];
      const params = {
        stat_types: statTypes.join(`||`),
      };

      const request = await this.$getCustomStats(path, params);
      if (request !== null) {
        this.playerStats = request.entity_stats;
      }
    },
  },
};
